export default __webpack_public_path__ + "static/media/InstagramLogoColor.5b339a13.svg";